import { BadgeIndianRupee, Bot, SlidersHorizontal, Eye, Target, Timer, LifeBuoy } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const PILLARS = [
  [BadgeIndianRupee, "Affordable Digital Solutions", "Beginner-friendly pricing that small businesses and startups can start with today."],
  [Bot, "AI-Powered Automation", "Chatbots, follow-ups and workflows that work for you around the clock."],
  [SlidersHorizontal, "Customized Approach", "Every setup is shaped around how your business actually runs."],
  [Eye, "Better Online Visibility", "Show up on Google, Maps and AI answer engines when customers search."],
  [Target, "Smarter Lead Management", "Capture, organise and follow up every lead so none slip away."],
  [Timer, "Time-Saving Technology", "Hand off repetitive tasks and get hours back every week."],
  [LifeBuoy, "Ongoing Support", "We stay with you after launch to maintain and improve your systems."],
];

export const WhyUs = () => (
  <section id="why" className="relative py-24 sm:py-32" data-testid="why-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
      <Reveal>
        <Eyebrow index="04">Benefits</Eyebrow>
        <h2 className="mt-6 max-w-3xl font-display text-4xl font-bold leading-[1.02] tracking-tight text-white sm:text-6xl">
          Seven reasons businesses <span className="text-outline">grow</span> with us.
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-12 lg:gap-5">
        {PILLARS.map(([Icon, t, d], i) => (
          <Reveal key={t} delay={(i % 4) * 0.06}
            className={`${i < 3 ? "lg:col-span-4" : "lg:col-span-3"} ${i === 6 ? "md:col-span-2 lg:col-span-3" : ""}`}>
            <div className="spot-card group flex h-full flex-col rounded-3xl border border-white/10 bg-[#0E1526] p-7" data-testid={`why-pillar-${i + 1}`}>
              <div className="flex items-center justify-between">
                <Icon className="h-6 w-6 text-[#00F0FF]" />
                <span className="font-mono text-xs text-slate-400">0{i + 1}</span>
              </div>
              <h3 className="mt-10 font-display text-xl font-bold text-white">{t}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-300">{d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
